/* 
    This file is almost identical to My-Assigned-Tickets-Reducers.js, but is used for the reassign tech drop down menu on ticket details screens
*/

const initialState = {
    active_assignment_name: "Unassigned",        // The name of the person currently selected in assigned to drop down menu
    active_assignment_id: 0,          // The user id of the person selected in the assigned to drop down
    assignment_change_detected: false,   // gets set to true if user clicks new option in the assigned to drop down menu of my assigned tickets table
    status_name: "Open",     // Value selected in the status drop down menu, default to Open
    status_change_detected: false,       // gets set to true if user clicks new option in the status drop down menu of my assigned tickets table
    type_name: "Unclarified",    // Value selected in the type drop down menu, default to Unclarified (Holding Table tickets)
    type_change_detected: false, // gets set to true if user clicks new option in the type drop down menu of my assigned tickets table
    priority_name: "All",       // Value selected in priority drop down menu, default to All
    priority_change_detected: false     // gets set to true if user clicks new option in the priority drop down menu of my assigned tickets table
};

function reassignTechReducer(state = initialState, action) {
    switch(action.type) {
        case "UPDATE_ACTIVE_ASSIGNMENT":
            //console.log("Login event detected");
            //console.log(action.payload);
            if(action.payload) {
                return {
                    ...state,
                    active_assignment_name: action.payload.name,
                    active_assignment_id: action.payload.id 
                };
            }
            break;

        case "UPDATE_ACTIVE_STATUS":
            if(action.payload) {
                return {
                    ...state,
                    status_name: action.payload
                };
            }
            break;

        case "UPDATE_ACTIVE_PRIORITY":
            if(action.payload) {
                return {
                    ...state,
                    priority_name: action.payload
                };
            }
            break;

        case "UPDATE_ACTIVE_TYPE":
            if(action.payload === "Unclarified") {
                return {
                    ...state,
                    type_name: action.payload,
                    priority_name: "All"        // unclarified does not have priorities
                };
            }
            else if(action.payload) {
                return {
                    ...state,
                    type_name: action.payload
                }
            }
            break;

        case "ALERT_ASSIGNMENT_CHANGE_FROM_DROPDOWN":   // only gets fired from selecting new tech to assign ticket to in ticket details page
            return {
                ...state,
                assignment_change_detected: true    // will prompt componentDidUpdate to reassign the ticket to the selected tech
            }

        case "ASSIGNMENT_CHANGE_RESOLVED":      // gets called from various details pages as soon as assigned to change detected so only fires function once
            return {
                ...state,
                assignment_change_detected: false
            }

        case "ALERT_STATUS_CHANGE_FROM_DROPDOWN":
            return {
                ...state,
                status_change_detected: true    // will prompt componentDidUpdate to repopulate assigned tickets table
            }

        case "STATUS_CHANGE_RESOLVED":
            return {
                ...state,
                status_change_detected: false
            }

        case "ALERT_PRIORITY_CHANGE_FROM_DROPDOWN":
            return {
                ...state,
                priority_change_detected: true    // will prompt componentDidUpdate to repopulate assigned tickets table
            }

        case "PRIORITY_CHANGE_RESOLVED":
            return {
                ...state,
                priority_change_detected: false
            }

        case "ALERT_TYPE_CHANGE_FROM_DROPDOWN":
            return {
                ...state,
                type_change_detected: true  // will prompt componentDidUpdate to repopulate assigned tickets table
            }

        case "TYPE_CHANGE_RESOLVED":
            return {
                ...state,
                type_change_detected: false
            }

        case "RESET_FILTERS":   // puts everything back to their default values. called on page load of my assigned tickets in case any left over data
            return {
                ...state,
                active_assignment_name: "Unassigned",        // The name of the person currently selected in assigned to drop down menu
                active_assignment_id: 0,          // The user id of the person selected in the assigned to drop down
                assignment_change_detected: false,   // gets set to true if user clicks new option in the assigned to drop down menu of my assigned tickets table
                status_name: "Open",     // Value selected in the status drop down menu, default to Open
                status_change_detected: false,       // gets set to true if user clicks new option in the status drop down menu of my assigned tickets table
                type_name: "Unclarified",    // Value selected in the type drop down menu, default to Unclarified (Holding Table tickets)
                type_change_detected: false, // gets set to true if user clicks new option in the type drop down menu of my assigned tickets table
                priority_name: "All",       // Value selected in priority drop down menu, default to All
                priority_change_detected: false     // gets set to true if user clicks new option in the priority drop down menu of my assigned tickets table
            }


        default:
            return state;


    }
}

export default reassignTechReducer;